module.exports = __webpack_public_path__ + "static/images/containers/BattleRooms/images/cap.32d3a047.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/images/cap.png
// module id = 2802
// module chunks = 11